import request from '../_helpers/request';

export const PaymentItemService = {
    GetPaymentItemList
    , InsertPaymentItem
    , GetPaymentHistory
    , GetPaymentByRefCodeOrEventSid
};

function GetPaymentItemList() {
    var url = "PaymentItem/GetPaymentItemList";
    var params = {};

    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.SystemErrorMsg;
            }
        })

}
function InsertPaymentItem(paymentItems) {
    var url = "PaymentItem/InsertPaymentItem";
    var params = {
        "paymentItems": paymentItems, "action": {
            "LangId": localStorage.getItem("currentLangId")
            , "IP": window.location.host
            , "URL": window.location.href
            , "Referral": document.referrer
            , "BAgent": window.navigator.userAgent

        }
    };

    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.SystemErrorMsg;
            }
        })

}
function GetPaymentHistory() {
    var url = "PaymentItem/GetPaymentHistory";
    var params = {
        "param": {
            "LangId": localStorage.getItem("currentLangId")
            , "IP": window.location.host
            , "URL": window.location.href
            , "Referral": document.referrer
            , "BAgent": window.navigator.userAgent

        }
    };

    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.SystemErrorMsg;
            }
        })
}
function GetPaymentByRefCodeOrEventSid(RefCode, EventSid) {
    var url = "PaymentItem/GetPaymentByRefCodeOrEventSid";
    var params = {
        "RefCode": RefCode
        , "EventSid" : EventSid
        , "action": {
            "LangId": localStorage.getItem("currentLangId")
            , "IP": window.location.host
            , "URL": window.location.href
            , "Referral": document.referrer
            , "BAgent": window.navigator.userAgent

        }
    };

    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return res.SystemErrorMsg;
            }
        })
}
